import { Injectable } from '@angular/core';
import { CookieService as NgxCookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  private readonly ACCESS_TOKEN_KEY = 'access_token';
  private readonly REFRESH_TOKEN_KEY = 'refresh_token';
  private readonly USER_DATA_KEY = 'user_data';

  constructor(private ngxCookieService: NgxCookieService) {}

  setAccessToken(token: string, expiresIn?: number): void {
    const expiresDate = expiresIn 
      ? new Date(Date.now() + expiresIn * 1000)
      : new Date(Date.now() + 24 * 60 * 60 * 1000);

    this.ngxCookieService.set(
      this.ACCESS_TOKEN_KEY,
      token,
      expiresDate,
      '/',
      undefined,
      true,
      'Strict'
    );
  }

  getAccessToken(): string | null {
    const token = this.ngxCookieService.get(this.ACCESS_TOKEN_KEY);
    return token || null;
  }

  setRefreshToken(token: string, expiresIn?: number): void {
    const expiresDate = expiresIn 
      ? new Date(Date.now() + expiresIn * 1000)
      : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);

    this.ngxCookieService.set(
      this.REFRESH_TOKEN_KEY,
      token,
      expiresDate,
      '/',
      undefined,
      true,
      'Strict'
    );
  }

  getRefreshToken(): string | null {
    const token = this.ngxCookieService.get(this.REFRESH_TOKEN_KEY);
    return token || null;
  }

  setUserData(userData: any): void {
    const expiresDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
    const userDataString = JSON.stringify(userData);

    this.ngxCookieService.set(
      this.USER_DATA_KEY,
      userDataString,
      expiresDate,
      '/',
      undefined,
      true,
      'Strict'
    );
  }

  getUserData(): any | null {
    const userDataString = this.ngxCookieService.get(this.USER_DATA_KEY);
    if (!userDataString) {
      return null;
    }

    try {
      return JSON.parse(userDataString);
    } catch (error) {
      return null;
    }
  }

  clearAll(): void {
    this.ngxCookieService.delete(this.ACCESS_TOKEN_KEY, '/');
    this.ngxCookieService.delete(this.REFRESH_TOKEN_KEY, '/');
    this.ngxCookieService.delete(this.USER_DATA_KEY, '/');
  }

  hasAccessToken(): boolean {
    return this.ngxCookieService.check(this.ACCESS_TOKEN_KEY);
  }

  hasRefreshToken(): boolean {
    return this.ngxCookieService.check(this.REFRESH_TOKEN_KEY);
  }
}
